import { TrackJS } from 'trackjs';

export function removeTrackJsMetadata() {
  if (TrackJS.isInstalled()) {
    TrackJS.configure({ userId: '' });
    TrackJS.removeMetadata('accountId');
    TrackJS.removeMetadata('accountName');
    TrackJS.removeMetadata('userId');
  }
}
